export default "__VITE_ASSET__D8CvOHJ2__"